module.exports = __webpack_public_path__ + "img/plan3_book12.6945f106.png";